import { getDatasetsInfo } from "~/api/interruptor/datasets"
import { getDataPage } from "~/api/prismic/singles"
import type { DataPageProps } from "~/screens/DataPage"
import { DataPage } from "~/screens/DataPage"
import { enhanceStaticProps } from "~/utils/next/enhanceStaticProps"
import { getPreviewRef } from "~/utils/prismic/previewData"

export const getStaticProps = enhanceStaticProps<DataPageProps>(
  async ({ previewData }) => {
    const [page, tableData] = await Promise.all([
      getDataPage({ ref: getPreviewRef(previewData) }),
      getDatasetsInfo(),
    ])

    if (!page) {
      return { notFound: true }
    }

    return {
      props: {
        ...page.data,
        tableData,
      },
    }
  },
)

export default DataPage
